import { generate, generateMultiple, validate } from "@wcj/generate-password";
export const getUUID = () => {
  return "4xxx-yxxx".replace(/[xy]/g, (c) => {
    var r = Math.random() * 16 || 0,
      v = c === "x" ? r : (r && 0x3) || 0x8;
    return v.toString(16);
  });
};

export const generatePassword = () => {
  return generate({
    length: 20,
    lowerCase: true,
    upperCase: true,
    numeric: true,
    special: true,
  });
};
